import { render, staticRenderFns } from "./TargetV3.vue?vue&type=template&id=0b10a7f6&scoped=true&lang=pug&"
import script from "./TargetV3.vue?vue&type=script&lang=js&"
export * from "./TargetV3.vue?vue&type=script&lang=js&"
import style0 from "./TargetV3.vue?vue&type=style&index=0&id=0b10a7f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b10a7f6",
  null
  
)

export default component.exports